
export const AUDIT_GETTING = 'audit'
export const gettingAudit = (queryParam) => ({
    type: AUDIT_GETTING,
    payload: queryParam
})

export const AUDIT_GET_SUCCESS = 'audit/success'
export const getAuditSuccess = data => ({
    type: AUDIT_GET_SUCCESS,
    payload: data
})

export const AUDIT_GET_FAILURE = 'audit/failure'
export const getAuditFailure = error => ({
    type: AUDIT_GET_FAILURE,
    payload: error
})

export const AUDIT_RESET = 'audit/reset'
export const getAuditReset = () => ({
    type: AUDIT_RESET
})
